import moment from 'moment'
import React from 'react'
import {Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select} from 'antd'
import _ from 'lodash'

import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import {hideLoader, showLoader} from '../../modules/actions'
import Request from '../../request'
import {connect} from 'react-redux'
import styles from '../../containers/Desk/counselling/all/styles.less'
import {RightsWrapper} from './utils'
const Option = Select.Option

@Form.create()
class SyncSpreadsheetForm extends React.Component {
    state = {
        visible: true,
        childrenDrawer: true,
        arr: [],
        loading: false,
        excelFieldArray: [],
        excelDatas: [],
        DBFieldsArray: [
            "studentName", 'status', "mode", "selectInquiryType", "dateOfBirth", "gender", "mobile", "watsupp", "emailId", "facebookEmail", "whichYearPlanningToGo", "enqType", "location", "caseHistory", "preference"
        ],
        fieldMappingArray: {},
        statusList: '',
        inputTypes: {
            fields: [
                {
                    label: 'Google Spreadsheet ID',
                    key: 'googleSpreadsheetId',
                    type: 'text',
                    required: true
                },
                {
                    label: 'Choose Sheet Index',
                    key: 'siteIndex',
                    type: 'select',
                    required: true,
                    width: 500,
                    options: [
                        0,1,2,3,4,5,6,7,8,9,10
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({siteIndex: v})
                    }
                },
                {
                    label: 'Mode',
                    key: 'location',
                    type: 'select',
                    width: 500,
                    options: ['Direct', 'Newspaper', 'Facebook', 'Google',
                    'Seminar', 'Education Fair', 'School/College Event', 'Conopy', 'Instagram', 'Justdial'],
                    onChange: v => {
                        this.setState({location: v});
                        this.props.form.setFieldsValue({location: v})
                    }
                },
                {
                    label: 'Status List',
                    key: 'statusList',
                    type: 'textarea',
                    required: true
                }
            ]
        }
    }

    setFieldMaping = (field, fieldKey) => {
        let fieldMappingArray = this.state.fieldMappingArray;
        fieldMappingArray[field] = fieldKey;
        this.setState({fieldMappingArray: fieldMappingArray});
    }

    submitMapingFields = e => {
        const {dispatch, form} = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            let {fieldMappingArray, excelDatas, statusList, siteIndex, googleSpreadsheetId, location} = this.state;
            if (!err) {
                let values = _.clone(valData)
                dispatch(showLoader());
                
                let x = await Request.setGoogleSpreadsheetData({fieldMappingArray, statusList, siteIndex, googleSpreadsheetId, location})

                dispatch(hideLoader())

                if (!x.error) {
                    this.onClose();
                    form.resetFields()
                    notification.success({
                        message: x.message
                    })
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.message
                    })
                }
            }
        })
    }

    componentDidMount() {
        
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = e => {
        const {dispatch, form} = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                dispatch(showLoader())

                let x = await Request.getGoogleSpreadsheetData(values)

                dispatch(hideLoader())

                if (!x.error) {
                    this.setState({excelFieldArray: x.fieldArray, excelDatas: x.excelDatas, statusList: values.statusList, googleSpreadsheetId: values.googleSpreadsheetId, siteIndex: values.siteIndex});
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.message
                    })
                }
            }
        })
    }

    render() {
        const {
            form: {getFieldDecorator, getFieldValue}
        } = this.props
        const { excelFieldArray, excelDatas, DBFieldsArray, statusList } = this.state;
        
        const fieldWidth = excelFieldArray.length > 0 ? 900 / excelFieldArray.length : 200;
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Sync Google Spreadsheet Inquiry Data
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={this.state.visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                        <div>
                            <GetAllFormFields
                                inputSchema={this.state.inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    PULL
                                </Button>
                            </Col>
                            <Col span={8}/>
                        </Row>
                    </Form>
                </Card>
                <Card>
                    {
                    excelFieldArray && excelFieldArray.length ? 
                        <Form onSubmit={this.submitMapingFields} style={{marginTop: 8}}>
                            <table className="ant-table-fixed">
                                <tbody className="ant-table-tbody">
                                    {                                
                                    excelFieldArray.map((field, indexExcelFieldArray) => {
                                            return (
                                                <tr key={indexExcelFieldArray} className="ant-table-row  ant-table-row-hover">
                                                    <th className="ant-table-fixed-columns-in-body ant-table-row-cell-break-word" width="300">{field}</th>
                                                    <td className="ant-table-fixed-columns-in-body ant-table-column-has-actions ant-table-column-has-filters ant-table-column-has-sorters ant-table-row-cell-break-word">
                                                        <Select
                                                            showSearch={true}
                                                            allowClear
                                                            optionFilterProp="children"
                                                            style={{
                                                                width: 214,
                                                                paddingRight: 16,
                                                                paddingLeft: 9
                                                            }}
                                                            placeholder="Select Field"
                                                            onChange={fieldKey => { this.setFieldMaping(field, fieldKey) }}
                                                        >
                                                            {DBFieldsArray.map((val, idn) => {
                                                                return (
                                                                    <Option key={idn} value={val}>
                                                                        {val}
                                                                    </Option>
                                                                )
                                                            })}
                                                        </Select>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                            <Row>
                                <Col span={8}/>
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{marginBottom: 10}}
                                        loading={this.props.loading}>
                                        SAVE
                                    </Button>
                                </Col>
                                <Col span={8}/>
                            </Row>
                        </Form>
                        :null
                    }
                </Card>
                <Card>
                    <table className="ant-table-fixed" style={{textAlign: 'center'}}>
                        <thead>
                            <tr className="ant-table-row  ant-table-row-hover">
                                {
                                excelFieldArray && excelFieldArray.length ? 
                                    excelFieldArray.map((field, indexField) => {
                                        return (
                                            <th key={indexField} className="ant-table-fixed-columns-in-body ant-table-row-cell-break-word" width={fieldWidth}>{field}</th>
                                        )
                                    })
                                :null
                                }                                
                            </tr>
                        </thead>
                        <tbody className="ant-table-tbody">
                            {
                            excelDatas && excelDatas.length ? 
                                excelDatas.map((excelData, indexExcel) => {
                                    return (
                                        <tr key={indexExcel} className="ant-table-row  ant-table-row-hover">
                                            {
                                                excelFieldArray && excelFieldArray.length ? 
                                                    excelFieldArray.map((field, indexExcelField) => {
                                                        return (
                                                            <td key={indexExcelField} className="ant-table-fixed-columns-in-body ant-table-column-has-actions ant-table-column-has-filters ant-table-column-has-sorters ant-table-row-cell-break-word">{excelData[field]}</td>
                                                        )
                                                    })
                                                :null
                                            }                                             
                                        </tr>
                                    )
                                })
                                :null
                            }
                        </tbody>
                    </table>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SyncSpreadsheetForm)
